import FirstStep from './1'
import SecondStep from './2'
import ThirdStep from './3'

const Forms = [FirstStep, SecondStep, ThirdStep]

export { Forms as default }
